import { render, staticRenderFns } from "./CmsListAuto.vue?vue&type=template&id=022e43f7&scoped=true"
import script from "./CmsListAuto.vue?vue&type=script&lang=js"
export * from "./CmsListAuto.vue?vue&type=script&lang=js"
import style0 from "./CmsListAuto.vue?vue&type=style&index=0&id=022e43f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022e43f7",
  null
  
)

export default component.exports